
/**
 * @export
 * @enum {string}
 */
export enum AccreditationStatus {
    EMPTY = 'EMPTY',
    ACCREDITED = 'ACCREDITED',
    NOT_ACCREDITED = 'NOT_ACCREDITED'
}